import { render } from "./ColorStyle.vue?vue&type=template&id=00dc8886"
import script from "./ColorStyle.vue?vue&type=script&lang=ts"
export * from "./ColorStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script